<div *ngFor="let label of labels" [class]="label.color + ' label'">
  {{label.name}}
</div>
